// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".showHintP[data-v-54c974f0]{font-size:10.4px!important;color:rgba(0,0,0,.6);padding:0 12px}", ""]);
// Exports
module.exports = exports;
